<script>
    import TagEditHeader from '@/components/page-tag-edit/tag-edit/TagEditHeader.vue';
    import TagEditData from '@/components/page-tag-edit/tag-edit/TagEditData.vue';

    export default {
        computed: {
            isShow() {return this.$store.getters.IS_SHOW_TAG_EDIT}
        },
        components: {
            TagEditHeader: TagEditHeader,
            TagEditData: TagEditData,
        }
    }
</script>


<template>
    <div
        v-if="isShow === true"
        class="left_additional_container"
    >
        <TagEditHeader />
        <hr class="hr_light_98">
        <TagEditData />
    </div>
</template>